import {Injectable} from '@angular/core';
import {BaseRestService} from '@shared/services/base-rest.service';
import {Form} from './models/form';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {TemplateEntity} from '@shared/model/template-entity';
import {FormVersion} from "./models/form-version";

@Injectable({
  providedIn: 'root'
})
export class FormService extends BaseRestService<Form> {
  entities: TemplateEntity[] = [];

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient, `${environment.apiBaseUrl}/ignite/application`);
  }

  saveForm(form: Form) {
    return this.createEntity(form);
  }

  override getById(id: any): Observable<Form> {
    return super.getById(id).pipe(map((data) => decodeData(data)));
  }

  getAllForms(): Observable<Form[]> {
    return this.http
      .get<Form[]>(this.restUrl + '/', {})
      .pipe(map((res) => res));
  }

  getByCategory(category: string): Observable<Form[]> {
    return this.http
      .get<Form[]>(this.restUrl + '?category=' + category, {})
      .pipe(map((res) => res));
  }

  toggleLock(id: any, shouldLock: boolean): Observable<string> {
    return this.http.post(
      `${this.restUrl}/toggleLock/${id}/${shouldLock}`,
      null,
      { responseType: 'text' }
    );
  }

  getFormVersions(formId: string): Observable<FormVersion[]> {
    return this.http.get<FormVersion[]>(`${this.restUrl}/forms/${formId}/versions`)
  }

  revertForm(formId: string, versionNumber: number): Observable<Form> {
    return this.http.get<Form>(`${this.restUrl}/revert/${formId}/${versionNumber}`);
  }
}

export function decodeData(data: Form) {
    const encoded = data?.components?.[0];
    if (encoded) {
      const decodedData = atob(encoded);
      if (data?.components) {
        data.components[0] = decodedData;
      }
  }
  return data;
}
